import dangerousGoods from '@/views/nativeRules/dangerousGoods.vue'
import forceMajeureProvision from '@/views/nativeRules/forceMajeureProvision.vue'

export default [
  {
    path: '/dangerousGoods',
    name: 'DangerousGoods',
    component: dangerousGoods,
    meta: {
      title: '',
      isApp: true
    }
  },
  {
    path: '/forceMajeureProvision',
    name: 'ForceMajeureProvision',
    component: forceMajeureProvision,
    meta: {
      title: '',
      isApp: true
    }
  }
]
